export default {
    getInstitutions: { method: 'get', url: 'institutions' },
    postInstitutions: { method: 'post', url: 'institutions' },
    putInstitutions: { method: 'put', url: 'institutions/{id}' },
    deleteInstitutions: { method: 'delete', url: 'institutions/{id}' },
}
